import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useLocation, Link } from 'react-router-dom';
import { useFetchMyPlaylistContent } from 'actions/playlists';
import { FILE_STATUS_VALUES } from 'actions/file';
import createLocation from 'utils/createLocation';
import { truncateText } from 'utils/ui';
import Box from 'components/Box';
import { Arrow } from 'components/icons';
import Flex from 'components/Flex';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import { CONTENT_TYPES } from 'utils/asset/constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var StickyFlex = styled(Flex).withConfig({
  displayName: "PlaylistNavigator__StickyFlex",
  componentId: "sc-7i8vpi-0"
})(["position:relative;@media (min-height:580px){position:sticky;}"]);
function getNextAsset(currentAssetId, contents) {
  var _allAssets$slice$find;
  if (!contents.length) return {
    nextAsset: null,
    currentPosition: null,
    assetCount: null
  };
  var allAssets = contents.filter(function (content) {
    return content.type !== CONTENT_TYPES.PLAYLIST && content.type !== CONTENT_TYPES.SECTION;
  });
  function isNavigable(asset) {
    return asset.fileStatus === FILE_STATUS_VALUES.READY || asset.type === CONTENT_TYPES.WEBLINK || asset.type === CONTENT_TYPES.EVENT || asset.download === 'required';
  }
  var currentAssetIndex = allAssets.findIndex(function (_ref) {
    var id = _ref.id;
    return id === currentAssetId;
  });
  var nextAsset = currentAssetIndex !== -1 ? (_allAssets$slice$find = allAssets.slice(currentAssetIndex + 1).find(isNavigable)) !== null && _allAssets$slice$find !== void 0 ? _allAssets$slice$find : null : null;
  return {
    nextAsset: nextAsset,
    currentPosition: currentAssetIndex + 1,
    assetCount: allAssets.length
  };
}
var MiddleDot = function MiddleDot() {
  return /*#__PURE__*/_jsx(Box, {
    width: 2,
    height: 2,
    mx: "xs",
    background: "text"
  });
};
function PlaylistNavigator(_ref2) {
  var assetId = _ref2.assetId,
    playlistId = _ref2.playlistId,
    playlistName = _ref2.playlistName;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _useFetchMyPlaylistCo = useFetchMyPlaylistContent({
      id: playlistId
    }),
    content = _useFetchMyPlaylistCo.items,
    isLoading = _useFetchMyPlaylistCo.isLoading,
    isError = _useFetchMyPlaylistCo.isError;
  if (isLoading || isError) {
    return null;
  }
  var _getNextAsset = getNextAsset(assetId, content),
    nextAsset = _getNextAsset.nextAsset,
    currentPosition = _getNextAsset.currentPosition,
    assetCount = _getNextAsset.assetCount;
  var nextAssetLink = nextAsset && createLocation(pathname, {
    asset: nextAsset.id,
    playlistId: playlistId
  });
  return /*#__PURE__*/_jsxs(StickyFlex, {
    bottom: true,
    mt: "auto",
    px: "m",
    py: "s",
    background: "shaded",
    borderTop: "thin",
    fontSize: "xs",
    lineHeight: 1.4,
    children: [/*#__PURE__*/_jsxs(Box, {
      shrink: true,
      overflow: "wrap",
      mr: "s",
      children: [nextAssetLink ? /*#__PURE__*/_jsxs(TextLink, {
        bold: true,
        stealthy: true,
        as: Link,
        to: nextAssetLink,
        children: [truncateText(t('asset_next_content', {
          name: nextAsset.name
        }), 75), /*#__PURE__*/_jsx(Box, {
          fillParent: true
        })]
      }) : /*#__PURE__*/_jsx(Text, {
        bold: true,
        children: t('end_of_playlist')
      }), /*#__PURE__*/_jsxs(Flex, {
        children: [/*#__PURE__*/_jsx(Box, {
          shrink: true,
          overflow: "ellipsis",
          children: playlistName
        }), /*#__PURE__*/_jsx(MiddleDot, {}), /*#__PURE__*/_jsx(Box, {
          children: t('pagination_current_slash_total', {
            current: currentPosition,
            total: assetCount
          })
        })]
      })]
    }), nextAsset && /*#__PURE__*/_jsx(Box, {
      ml: "auto",
      mr: "-xxs",
      textColor: "links",
      children: /*#__PURE__*/_jsx(Arrow, {
        disablePointerEvents: true,
        flip: "x"
      })
    })]
  });
}
export default PlaylistNavigator;